import * as React from 'react';
import { connect } from 'react-redux';
import {
    fetchPublicacion,
    editPublicacion,
    fetchTiposPublicacion,
    fetchTiposAlicuotasIva,
} from '../../../../actions/publicacionesActions';
import { DropDownArrow, profileSelectStyle } from "../../../../template/CustomStyle";
import { currencyFormat } from '../../../../helper/publicacionHelper';
import { fetchRebate } from '../../../../actions/rebatesActions';
import Select from 'react-select';
import Rebate from './Rebate';
import PropTypes from 'prop-types';

class PrecioPago extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rebate: this.props.rebate,
            alicuotaIva: null,
            alicuotaImpuestoInterno: this.props.publicacion?.alicuotaImpuestoInterno?.toString() || "0",
        };
        this.precioListaInputRef = React.createRef();
    }

    componentDidMount = () => {
        if (this.precioListaInputRef.current && !this.props.userType.isAdminMod && window.innerWidth >= 992) {
            this.precioListaInputRef.current.focus();
        }

        if (!Array.isArray(this.props.alicuotasIva) || this.props.alicuotasIva.length === 0) {
            this.props.fetchTiposAlicuotasIva();
        }
        this.setAlicuotaIvaFromProps();
    };


    componentDidUpdate(prevProps) {
        if (prevProps.publicacion?.alicuotaIva !== this.props.publicacion?.alicuotaIva ||
            prevProps.alicuotasIva !== this.props.alicuotasIva) {
            this.setAlicuotaIvaFromProps();
        }
    }

    setAlicuotaIvaFromProps = () => {
        const { alicuotasIva, publicacion } = this.props;

        const encontrada = Array.isArray(alicuotasIva)
            ? alicuotasIva.find(
                (iva) => String(iva?.alicuota ?? '') === String(publicacion?.alicuotaIva ?? '')
            )
            : null;

        this.setState({
            alicuotaIva: encontrada
                ? {
                    label: `${encontrada.alicuota}%`,
                    value: encontrada.alicuota.toString()
                }
                : null
        });
    };

    selectSearchHandler = (option, { name }) => {
        const publicacion = { ...this.props.publicacion };

        switch (name) {
            case "alicuotaIva":
                publicacion.alicuotaIva = option.label.replace('%', '');
                this.setState({ alicuotaIva: option });
                break;

            case "idTipoPublicacion":
                publicacion.idTipoPublicacion = option.value;
                publicacion.tipoPublicacion = Array.isArray(this.props.tiposPublicacion)
                    ? this.props.tiposPublicacion.find(
                        (tipo) => String(tipo?.id ?? tipo?.codigo ?? tipo?.idTipoPublicacion ?? '') === String(option.value)
                    ) || {}
                    : {};
                break;

            default:
                publicacion[name] = option.value;
                break;
        }

        this.props.editPublicacion(publicacion);
    };

    handleInputChange = (event) => {
        if (!event) {
            console.error("Evento inválido en handleInputChange");
            return;
        }

        let publicacion = { ...this.props.publicacion };
        const { name, value } = event.target;
        let newValue = value;

        switch (name) {
            case "precioPromocional":
            case "precioLista":
                newValue = currencyFormat(value);
                break;

            case "alicuotaImpuestoInterno": {
                const formattedValue = value.replace(",", ".");
                this.setState({ alicuotaImpuestoInterno: formattedValue });

                const parsedValue = Number.parseFloat(formattedValue);
                if (!Number.isNaN(parsedValue)) {
                    newValue = parsedValue;
                }
                break;
            }
            default:
                publicacion[name] = value;
                break;
        }

        this.props.editPublicacion({
            ...this.props.publicacion,
            [name]: newValue,
        });
    };

    updateDataRebate = (id) => {
        this.props.fetchRebate(id);
        this.setState({ rebate: this.props.rebate });
    }

    onSelectSearchInputTipo = () => {
        if (!this.props.isEditing) {
            this.props.fetchTiposPublicacion(this.props.publicacion.idSeller);
        } else {
            this.props.fetchTiposPublicacion(this.props.publicacion.seller.codigo);
        }
    }

    onSelectSearchInputMarcas = () => {
        this.props.fetchTiposAlicuotasIva();
    }

    fetchComision = () => {
        const { publicacion } = this.props;

        return publicacion?.tipoPublicacion?.comision || 0;
    };

    fetchOpcionesIva = () => {
        const { alicuotasIva } = this.props;

        const opcionesIva = Array.isArray(alicuotasIva)
            ? alicuotasIva
                .filter((item) => item != null)
                .map((item) => ({
                    label: `${item?.alicuota ?? ''}%`,
                    value: String(item?.id ?? ''),
                }))
            : [];

        return opcionesIva;
    };

    fetchListaTipo = () => {
        const { tiposPublicacion } = this.props;

        if (!Array.isArray(tiposPublicacion)) return [];

        return tiposPublicacion
            .filter((tipo) => tipo != null)
            .map((tipo) => ({
                label: tipo?.descripcion ?? '',
                value: String(tipo?.id ?? tipo?.codigo ?? tipo?.idTipoPublicacion ?? ''),
            }))
            .filter((item) => item.label !== '' && item.value !== '');
    };

    fetchTipoVal = (listaTipo) => {
        const { publicacion } = this.props;

        // Si no existe, devuelve el de la publicación (mostrarlo aunque no esté en API)
        if (publicacion?.tipoPublicacion?.descripcion) {
            return {
                label: publicacion.tipoPublicacion.descripcion,
                value: publicacion.idTipoPublicacion?.toString() || "0",
            };
        }
    };

    render() {

        const comision = this.fetchComision();
        const opcionesIva = this.fetchOpcionesIva();

        const listaTipo = this.fetchListaTipo();
        const tipoVal = this.fetchTipoVal(listaTipo);

        const tipoPublicacion = this.props.publicacion.tipoPublicacion?.descripcion || "";

        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="row">
                    <div className="col-12 col-md-6 form-group">
                        <label htmlFor="precioListaPrecioPago">Precio Lista</label>
                        <input
                            id="previoListaPrecioPago"
                            type="text"
                            className="form-control"
                            disabled={this.props.userType.isAdminMod}
                            value={this.props.publicacion.precioLista}
                            onChange={this.handleInputChange}
                            name="precioLista"
                            ref={this.precioListaInputRef}
                        />
                    </div>

                    <div className="col-12 col-md-6 form-group">
                        <label htmlFor="precioOfertaPrecioPago">Precio Oferta</label>
                        <input
                            id="precioOfertaPrecioPago"
                            type="text"
                            className="form-control"
                            disabled={this.props.userType.isAdminMod}
                            value={this.props.publicacion.precioPromocional}
                            onChange={this.handleInputChange}
                            name="precioPromocional"
                        />
                    </div>

                    <div className="col-12 col-md-6 form-group">
                        <label htmlFor="alicuotaIvaPrecioPago">Alícuota IVA</label>
                        <Select
                            id="alicuotaIvaPrecioPago"
                            name="alicuotaIva"
                            value={this.state.alicuotaIva}
                            options={opcionesIva}
                            onChange={(option) => this.selectSearchHandler(option, { name: "alicuotaIva" })}
                            styles={profileSelectStyle}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            onMenuOpen={this.onSelectSearchInputMarcas}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>

                    <div className="col-12 col-md-6 form-group">
                        <label htmlFor="alicuotaImpuestoPrecioPago">Alícuota Impuesto Interno</label>
                        <input
                            id="alicuotaImpuestoPrecioPago"
                            type="text"
                            className="form-control"
                            value={this.state.alicuotaImpuestoInterno}
                            name="alicuotaImpuestoInterno"
                            onChange={this.handleInputChange}
                        />

                    </div>

                    <div className="col-12 col-md-6 form-group">
                        <label htmlFor={this.props.userType.isAdminMod ? "tipoPublicacionPrecioPago" : "selectTipoPublicacionPrecioPago"}>Tipo de publicacion</label>
                        {this.props.userType.isAdminMod ? (
                            <input
                                id="tipoPublicacionPrecioPago"
                                disabled
                                className="form-control"
                                value={tipoPublicacion}
                                name="idTipoPublicacion"
                            />
                        ) : (
                                <Select
                                id="selectTipoPublicacionPrecioPago"
                                name="idTipoPublicacion"
                                value={tipoVal}
                                options={listaTipo}
                                onChange={(option) => this.selectSearchHandler(option, { name: "idTipoPublicacion" })}
                                onInputChange={this.onSelectSearchInputTipo}
                                styles={profileSelectStyle}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                            />
                        )}
                    </div>

                    <div className="col-12 col-md-6 form-group">
                        <label htmlFor="comisionPrecioPago">Comisión</label>
                        <input
                            id="comisionPrecioPago"
                            type="number"
                            disabled={this.props.userType.isAdminMod}
                            className="form-control"
                            value={this.props.userType.isAdminMod ? this.props.publicacion?.tipoPublicacion?.comision : comision}
                            name="comision"
                        />
                    </div>
                </div>

                <Rebate
                    publicacion={this.props.publicacion}
                    userType={this.props.userType}
                    rebate={this.props.rebate}
                    idUsuario={this.props.idUsuario}
                    updateDataRebate={this.updateDataRebate}
                />
            </div>
        );
    }
}
PrecioPago.propTypes = {
    // Redux props
    idUsuario: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    rebate: PropTypes.object,
    publicacion: PropTypes.shape({
        alicuotaImpuestoInterno: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        alicuotaIva: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        idSeller: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        seller: PropTypes.shape({
            codigo: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        }),
        tipoPublicacion: PropTypes.shape({
            comision: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            descripcion: PropTypes.string,
        }),
        idTipoPublicacion: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        precioLista: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        precioPromocional: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    userType: PropTypes.shape({
        isAdminMod: PropTypes.bool,
    }),
    alicuotasIva: PropTypes.array,
    tiposPublicacion: PropTypes.array,
    isEditing: PropTypes.bool,
    //Actions props
    fetchTiposAlicuotasIva: PropTypes.func,
    editPublicacion: PropTypes.func,
    fetchRebate: PropTypes.func,
    fetchTiposPublicacion: PropTypes.func,
}

const mapStateToProps = (state) => ({
    publicacion: state.publicaciones.publicacion,
    tiposPublicacion: state.publicaciones.tiposPublicacion,
    userType: state.general.userType,
    idUsuario: state.general.userId,
    rebate: state.rebates.rebate,
    alicuotasIva: state.publicaciones.tiposAlicuotaIva,
});

export default connect(mapStateToProps, {
    fetchPublicacion,
    editPublicacion,
    fetchTiposPublicacion,
    fetchRebate,
    fetchTiposAlicuotasIva,
})(PrecioPago);